import React, { useState, useMemo } from "react";
import { useSequence } from "../../../hooks/fetch_api_hook/useSequence";
import { useClasseContext } from "../../../context/ClasseContext";
import { useUser } from "../../../context/UserContext";
import { url } from "../../../utils/confserveur";
import RoadMapGroupe from "./RoadMapGroupe";
import Loading from "../../general/Loading";

function ProgressionGroupe() {
  const { groupNom, classeDetail } = useClasseContext();
  const { user, etablissementData } = useUser();
  const [reloadSequence, setReloadSequence] = useState(false);
  const [selectedView, setSelectedView] = useState("planning"); // Vue par défaut : planning
  const { data: listSequences, isLoading } = useSequence(
    `${url}sequences/?etablissement=${etablissementData.id}`,
    reloadSequence
  );

  // Obtenir le niveau depuis classeDetail
  const selectedNiveau = useMemo(() => {
    if (classeDetail) {
      return classeDetail.niveau;
    }
    return null;
  }, [classeDetail]);

  // Filtrer les séquences pour le groupe sélectionné
  const filteredSequences = useMemo(() => {
    if (!listSequences || !groupNom || !selectedNiveau) return [];
    return listSequences.filter(
      (sequence) => sequence.niveau === selectedNiveau && sequence.est_commune
    );
  }, [listSequences, groupNom, selectedNiveau]);

  // Gestion du rechargement des séquences
  const handleReload = () => {
    setSelectedView("planning");
    setReloadSequence((prevState) => !prevState);
  };

  const handleChangeView = (view) => {
    setSelectedView(view);
    if (view === 'progress') {
      setReloadSequence((prevState) => !prevState);
    }
  };

  const onToggleAccompli = () => {
    return true;
  };

  if (isLoading) {
    return (
      <Loading loadingText={"Chargement des séquences.."} />
    );
  }

  return (
    <div className="flex flex-col w-full h-full pilotage-enter">
      {/* RoadMapGroupe avec les onglets intégrés */}
      <RoadMapGroupe
        filteredSequences={filteredSequences}
        selectedNiveau={selectedNiveau}
        groupNom={groupNom}
        selectedView={selectedView}
        onChangeView={handleChangeView}
        // Props pour SuiviProgressionGroupe
        groupes={etablissementData && etablissementData.groupes}
        listSequences={listSequences}
        profGroupIds={etablissementData && etablissementData.professeurs.find((prof) => prof.id === user.id)?.groupes}
        onToggleAccompli={onToggleAccompli}
        handleReload={handleReload}
      />
    </div>
  );
}

export default ProgressionGroupe;
